import { UnitStatusEnum } from '@/enums/UnitStatus';

export const DEFAULT_MIN_PRICE = 0;
export const DEFAULT_MAX_PRICE = 3000;

// Statuses to include (excluding Rented and Sold) - Upcoming est obsolète, toutes les entrées ont été migrées vers Available
export const DEFAULT_RENTAL_UNIT_STATUSES = [UnitStatusEnum.Available, UnitStatusEnum.Reserved];

export const DEFAULT_RENTAL_VALID_UNIT_STATUSES = [UnitStatusEnum.Upcoming, UnitStatusEnum.Available, UnitStatusEnum.Reserved];